import styled from 'styled-components';

export const IconWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const GraphContainer = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: center;
  height: 100%;
  .echarts-tooltip span:not(:last-of-type) {
    font-weight: 400 !important;
  }
`;
